import React, { useState } from 'react';
import styles from './RegisterForm.scss';
import Markdown from './Markdown';
import Config from '../utils/Config';
import ButtonRound from './ButtonRound';
import FormError from './FormError';
import getUid from '../utils/getUid';
import TextField from './MaterialUi/TextField';
import Checkbox from './MaterialUi/Checkbox';
import EmailDoiModal from "./EmailDoi/Modal";
import PasswordField, { passwordCheck } from './MaterialUi/PasswordField';
import Button from './MaterialUi/Button';

export interface IRegisterFormOptions {
    headline?: string;
    button?: string;
}

export interface IRegisterOptions {
    headline?: string;
    description?: string;
    button?: string;
}

export interface IRegisterFormProps {
    registerOptions?: IRegisterOptions; // headline/button text for register modal, used in handleGoToRegister
    className?: string;
    onSubmit: (ev?: React.FormEvent, salt?: string, secret?: string) => void;
    name: string;
    setName: (name: string) => void;
    pass: string;
    setPass: (pass: string) => void;
    dataProcessingAccepted: boolean;
    setDataProcessingAccepted: (value: boolean) => void;
    termsAccepted: boolean;
    setTermsAccepted: (value: boolean) => void;
    isLoading: boolean;
    error: string;
}

// export interface IRegisterFormState {
//     mail: string;
//     pass1: string;
//     dataProcessingAccepted: boolean;
//     // acceptDoubleOptIn: boolean;
//     error: string;
//     isLoading: boolean;
// }

const RegisterForm: React.FC<React.PropsWithChildren<IRegisterFormProps>> = ({
    onSubmit,
    name,
    setName,
    pass,
    setPass,
    dataProcessingAccepted,
    setDataProcessingAccepted,
    termsAccepted,
    setTermsAccepted,
    registerOptions = {},
    className = '',
    error,
    isLoading
}) => {
    const [labelUid] = React.useState(() => getUid('formId'));

    const [submitError, setSubmitError] = useState('');

    const button = registerOptions?.button || 'Neues Benutzerkonto erstellen';

    const [isOpen, setIsOpen] = React.useState(false);

    const [event, setEvent] = React.useState(null);

    // const canSubmit = name && pass && termsAccepted;

    const handleSubmit = (ev: React.FormEvent) => {
        ev.preventDefault();
        setEvent(ev);

        if (!name) {
            setSubmitError('Bitte gib eine E-Mail-Adresse ein');
            return false;
        }

        if (!pass) {
            setSubmitError('Bitte gib ein gültiges Passwort ein');
            return false;
        }


        if (termsAccepted) {
            setSubmitError('');
            //start email doi
            handleOpen();
        } else {
            // not reached, when checkbox termsAccepted is marked as required
            setSubmitError('Bitte akzeptiere die AGB');
            return false;
        }
    };

    const registerUser = (salt?: string, secret?: string) => {
        handleClose();
        return onSubmit(event, salt, secret);
    }

    const handleOpen = () => {
        setIsOpen(true);
    };

    const handleClose = () => {
        setIsOpen(false);
    };

    const isValid = name && pass && termsAccepted;

    return (
        <form className={styles.registerForm} method="post" acceptCharset="UTF-8" onSubmit={handleSubmit}>
            <TextField
                label="E-Mail-Adresse"
                type="email"
                id={`${labelUid}Name`}
                name="name"
                value={name}
                // inputSize="60"
                inputProps={{ 
                    maxLength: 254,
                    autoComplete: "email",
                }}
                required={true}
                className="form-email required form-item__textfield"
                aria-required="true"
                onChange={(ev) => {
                    setName(ev.target.value);
                }}
            />

            <PasswordField
                label="Passwort"
                name="pass"
                value={pass}
                onChange={(value) => {
                    setPass(value);
                }}
            />

            <FormError text={submitError || error} />

            {/* <input type="hidden" name="form_build_id" value="form-miLwM2X8Y6T_0c_FDSK9pSmxq0Yw3JpCo_nQXCG7IyQ" className="form-item__textfield" />
            <input data-drupal-selector="edit-user-register-form" type="hidden" name="form_id" value="user_register_form" className="form-item__textfield" /> */}
            <div className={styles.terms}>


                {/* <Checkbox
                    // value="acceptTerms"
                    name="dataProcessingAccepted"
                    label={
                        <Markdown linkTarget="_blank" className={styles.dataProcessing}>
                            {Config.get('registerModal.dataProcessing')}
                        </Markdown>
                    }
                    onChange={() => {
                        setDataProcessingAccepted(!dataProcessingAccepted);
                    }}
                    value={dataProcessingAccepted}
                /> */}
                <Checkbox
                    required={true}
                    name="termsAccepted"
                    label={
                        <>
                            Ich habe die{' '}
                            <a href="/agb" target="_blank">
                                Nutzungsbedingungen/AGB
                            </a>{' '}
                            gelesen und erkläre mich damit einverstanden.
                        </>
                    }
                    onChange={() => {
                        setTermsAccepted(!termsAccepted);
                    }}
                    value={termsAccepted}
                />
            </div>
            <div className={styles.actions}>
                <Button type="submit" loading={isLoading} visualDisabled={!isValid} disabled={!isValid}>
                    {button}
                </Button>
            </div>
            <div className={styles.terms}>
                <Markdown className={styles.privacy} linkTarget="_blank">{Config.get('registerModal.terms')}</Markdown>
            </div>
            <div className={styles.annotation}>
                * die gekennzeichneten Felder sind Pflichtfelder
            </div>


            <EmailDoiModal
                open={isOpen}
                onClose={handleClose}
                userMail={name}
                isLoading={isLoading}
                onSubmitAction={registerUser}
            >
            </EmailDoiModal>

        </form>
    );
};

export default RegisterForm;
